{
  "#UTILITIES": {
    "WELCOME": "{{userFullName}}",
    "CHANGE_ACCOUNT": {
      "TITLE": "Firma wechseln",
      "SUBMIT": "Bestätigen",
      "SUCCESS_MESSAGE": "Die Firma wurde gewechselt",
      "ERROR_MESSAGE": "Die Firma konnte nicht gewechselt werden"
    },
    "CONTEXT": {
      "TITLE": "Angemeldet als",
      "SAVE": "Speichern",
      "SUCCESS": "Die Verkaufsorganisation wurde gewechselt",
      "NOT_SUPPORTED": "Der Context kann bei dieser Anmeldeart nicht gewechselt werden",
      "NO_COMPONENTS": "Es wurden keine Komponenten zum Editieren des Contexts gesetzt",
      "DETAIL_CONTEXT_SETTINGS": "Weitere Einstellungen öffnen..."
    },
    "VKFORG": {
      "LABEL": "Verkaufsorganisation (Vkforg)"
    },
    "FIRMA": {
      "LABEL": "Firma"
    },
    "ACCOUNT_CONTEXT": {
      "LABEL": "Firma",
      "CHANGE": "Ändern"
    },
    "USER_CONTEXT": {
      "LABEL": "Benutzer"
    },
    "SETTINGS": {
      "TITLE": "Einstellungen",
      "USER_CONTACT": {
        "TITLE": "Kontakt",
        "SUBMIT": "Speichern",
        "NO_DEFINITION": "Es konnte keine Definition gefunden werden",
        "SUCCESS": "Der Kontakt wurde geändert"
      },
      "CONTEXT": {
        "TITLE": "Context"
      }
    },
    "NOTIFICATIONS": {
      "TITLE": "Nachrichten",
      "UNREAD": "Ungelesene",
      "ALL": "Alle",
      "MARK_ALL_AS_READ": "Alle als gelesen markieren",
      "DELETE": "Löschen",
      "MARK_AS_READ": "Gelesen",
      "NO_DATA": "Es sind keine Benachrichtigungen vorhanden"
    }
  },
  "#CONNECTION_SETTINGS": {
    "TITLE": "Verbindungen",
    "SELECTED_CONNECTION": "Ausgewählte Verbindung",
    "NAME": "Name",
    "NAME_OPTIONAL": "(optional)",
    "HOST": "Host",
    "PORT": "Port",
    "BASE_PATH": "Basis Pfad",
    "SELECT": "Auswählen",
    "TEST": "Testen",
    "SAVE": "Speichern",
    "ADD": "Hinzufügen",
    "EDIT": "Bearbeiten",
    "SCAN": "Scannen",
    "DELETE": "Löschen",
    "DELETE_CONFIRM": "Möchten Sie die Verbindung wirklich löschen?",
    "SAVE_SUCCESS": "Die Verbindung wurde gespeichert!",
    "CHANGE_SUCCESS": "Die Verbindung wurde gewechselt!",
    "DELETE_SUCCESS": "Die Verbindung wurde gelöscht!",
    "SAVE_FAILURE": "Die Verbindung konnte nicht gespeichert werden!",
    "MESSAGES": {
      "TEST_SUCCESS": "Die Verbindung wurde erfolgreich getestet",
      "TEST_FAILURE": {
        "NO_CONNECTION": "Es konnte keine Verbindung zum Server hergestellt werden!",
        "NOT_VALID": "Die Verbindung ist nicht gültig!",
        "CLIENT": "Ein Clientseitiger Netzwerkfehler ist aufgetreten!",
        "UNKNOWN": "Ein unerwarteter Fehler ist aufgetreten!"
      },
      "NO_CONNECTION": {
        "TITLE": "Warnung",
        "MESSAGE": "Es wurde noch keine Verbindung ausgewählt"
      },
      "SCAN_ERROR": "Der gescannte Code beinhaltet keine gültige Verbindung",
      "SCAN_SUCCESS": "Die Verbindung wurde hinzugefügt!",
      "SCAN_EXISTING": "Die Verbindung wurde gewechselt!"
    },
    "LINKS": {
      "LOGIN": "<< Zurück zum Login"
    },
    "DIALOGS": {
      "EDIT": "Verbindung bearbeiten",
      "NEW": "Verbindung erstellen"
    }
  }
}
